import { useState, useEffect, useRef } from 'react'
import useClient from './useClient'
import { UUID } from "uuidjs";

export default function useProfile() {
  const [profile, setProfile] = useState({})
  const [addresses, setAddresses] = useState([])
  const [profileAddress, setProfileAddress] = useState({})
  const [invoiceAddresses, setInvoiceAddresses] = useState([])
  const [deliveryAddresses, setDeliveryAddresses] = useState([])
  const {
    client, tokenData
  } = useClient()
  const uid = useRef(UUID.generate())

  const update = async (profileData) => {
    try {
      let result = await client.user.setProfile(profileData)
      return result.data
    } catch (error) {
      return { success: false, code: 500, message: '', data: error }
    }
  }

  const updateAddress = async (address) => {
    try {
      let result = await client.user.setAddress(address)
      return result.data
    } catch (error) {
      return { success: false, code: 500, message: '', data: error }
    }
  }

  const addAddress = async (address) => {
    try {
      delete address.id
      let result = await client.user.setAddress(address)
      return result.data
    } catch (error) {
      return { success: false, code: 500, message: '', data: error }
    }
  }

  const deleteAddress = async (id) => {
    try {
      let result = await client.user.deleteAddress(id)
      return result.data
    } catch (error) {
      return { success: false, code: 500, message: '', data: error }
    }
  }

  const onAddressesRefreshed = (data) => {
    setAddresses([...data.addresses])
  }

  const onProfileRefreshed = (data) => {
    setProfile({...data.profile})
  }

  const refresh = () => {
    if (client) {
      client.user.getProfile()
      client.user.getAddresses()
    }
  }

  useEffect(() => {
    if (typeof addresses.filter !== 'function') return null
    setInvoiceAddresses(addresses.filter(e => e.addressType === 1))
    setDeliveryAddresses(addresses.filter(e => e.addressType === 2))
    let profileAddresses = addresses.filter(e => e.addressType === 0)
    if (profileAddresses.length > 0) setProfileAddress(profileAddresses[0])
    else setProfileAddress({})
  }, [addresses])

  useEffect(() => {
    if (client) {
      client.user.addCallback('onAddressesRefreshed', uid.current, onAddressesRefreshed)
      client.user.addCallback('onProfileRefreshed', uid.current, onProfileRefreshed)
      setProfile(client.user.profile)
      setAddresses(client.user.addresses || [])
    }
    return () => {
      // ON UNMOUNT
      if (client != null) {
        client.user.removeCallback('onAddressesRefreshed', uid.current)
        client.user.removeCallback('onProfileRefreshed', uid.current)
      }
    }
  }, [client])

  useEffect(() => {
    if (tokenData?.tokenType === 'user') {
      refresh()
    } else {
      if (tokenData != null) {
        setProfile({})
        setAddresses([])
      }
    }
  }, [tokenData])

  return {
    profile,
    addresses,
    update,
    addAddress,
    updateAddress,
    deleteAddress,
    profileAddress,
    invoiceAddresses,
    deliveryAddresses,
    refresh
  }
}
